import { useCallback, useEffect, useState } from 'react';
import { API } from '../../api';
import { PagedResultState } from '../../common/CommonResult';
import queryString from 'query-string';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  Layout,
  Select,
  Space,
  Table,
  TablePaginationConfig,
  Popconfirm,
  message,
  Tag,
  Card,
  Input,
  Button,
} from 'antd';
import { AddressCascaderOld } from '../../lib/AddressCascaderOld';
import { ScanModal } from '../../lib/parcel/ScanModal';
import dayjs from 'dayjs';
import { ForeignCustomers } from '../../lib/ForeignCustomer';
import DraftParcelDetail from './DraftParcelDetail';
import CreateOrderdraftPackage from './CreatePackage';
import CustomerSelect from '../../lib/CustomerSelect';
import AddressCascader from '../../lib/AddressCascader';
import AddressZipcodeCascader from '../../lib/AddressZipcodeCascader';

const toko = '0YznqkVjQMI4Jk1WKBWASPKzWOMRe/khW74N81CUnWmHMVTppMxyUMK5v4UzsO8w';

const OrderDraft = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchState, changeSearchState] = useState<any>({});
  const [showCreatePackage, changeShowCreatePackage] = useState(false);
  const [showDetail, changeShowDetail] = useState<any>({
    visible: false,
    item: null,
  });
  const [state, changeState] = useState<PagedResultState<any>>({
    loading: true,
    result: {},
  });
  const [query, changeQuery] = useState('');
  const [fixAddress, changeFixAddress] = useState<any>({});
  useEffect(() => {
    if (location.search) {
      changeSearchState(queryString.parse(location.search));
      fetchContent(location.search);
    } else {
      navigate(`?page=1`);
    }
  }, [location.search, navigate]);
  const changeSearch = useCallback(
    (val: any) => {
      const res = { ...queryString.parse(location.search), ...val };
      navigate(`?${queryString.stringify(res)}`);
    },
    [navigate, location]
  );
  const fetchContent = async (filter: any) => {
    try {
      changeState({ loading: true, result: {} });
      const response = await API.get({ apiVersion: 'api' })(`/order_draft/parcel/list${filter}`);
      changeState({ loading: false, result: response.result });
    } catch (e) {
      changeState({ loading: false, error: true, result: {}, errors: e });
    }
  };
  const syncParcel = async (trackingNumber: string, zipcode: string) => {
    try {
      const response = await API.post({
        apiVersion: 'api',
        withCredentials: true,
      })(`/order_draft/parcel/sync`, { trackingNumber, zipcode });
      changeFixAddress({});
      fetchContent(location.search);
    } catch (e) {
      message.error('sync error');
    }
  };
  const handleTableChange = (pagination: TablePaginationConfig) => {
    const params = queryString.parse(location.search);
    const search = {
      ...params,
      page: pagination.current || 1,
      size: pagination.pageSize,
    };
    navigate(`/order_draft/parcels?${queryString.stringify(search)}`);
  };
  const columns = [
    {
      title: '№',
      dataIndex: 'no',
      width: 70,
    },
    {
      title: 'Barcode №',
      dataIndex: 'trackingNumber',
      width: 150,
      key: 'trackingNumber',
      render: (row: any, item: any) => (
        <span onClick={() => changeShowDetail({ visible: true, item: item.trackingNumber })}>
          {row}
        </span>
      ),
    },
    {
      title: 'Богц',
      width: 100,
      dataIndex: 'orderPackage',
      render: (pkg: any) =>
        pkg ? (
          <Link to={`/order_draft/packages?page=1&packageNumber=${pkg?.packageNumber}`}>
            {pkg?.packageNumber}
          </Link>
        ) : null,
    },
    {
      title: 'Харилцагч',
      dataIndex: 'customer',
      width: 150,
      render: (data: any) => data?.name,
      key: 'customerName',
    },
    {
      title: 'Хаяг',
      width: 350,
      // textWrap: 'word-break',
      // ellipsis: true,
      render: (data: any) => (
        <div style={{ wordWrap: 'break-word', wordBreak: 'break-word' }}>{data}</div>
      ),
      dataIndex: 'receiverAddress',
      key: 'receiverAddress',
    },
    {
      title: 'Zipcode',
      width: 100,
      dataIndex: 'receiverPostalcode',
      key: 'receiverPostalcode',
    },
    {
      title: 'Захиалга',
      width: 100,
      dataIndex: 'orderNo',
      key: 'orderNo',
    },

    {
      title: 'Огноо',
      dataIndex: 'createdAt',
      render: (row: any) => dayjs(row).format('YYYY-MM-DD HH:mm:ss'),
      key: 'createdAt',
    },
    {
      title: 'Action',
      render: (data: any) => {
        return (
          <span>
            <Popconfirm
              title="Хаяг шинэчлэх"
              open={data.no === fixAddress?.order?.no}
              onConfirm={() => syncParcel(data.trackingNumber, fixAddress.zipcode)}
              onCancel={() => changeFixAddress({})}
              description={`Та энэ илгээмжийн зиф кодыг ${fixAddress.zipcode} кодоор солихдоо итгэлтэй байна уу`}
            >
              <span />
            </Popconfirm>
            {data.orderNo == null && (
              <AddressZipcodeCascader
                onChange={(e: any) => {
                  if (e.length === 3) {
                    changeFixAddress({ zipcode: e[2], order: data });
                  }
                }}
              />
            )}
          </span>
        );
      },
      key: 'status',
    },
  ];
  return (
    <Layout.Content style={{ margin: '24px 16px 0' }}>
      <Card
        title={`Урьдчилсан захиалгын илгээмж - ${state.result?.total ?? 0}`}
        extra={
          <>
            <Button onClick={() => changeShowCreatePackage(true)} type="primary">
              Богц үүсгэх
            </Button>
            {searchState.packageNumber && (
              <Tag
                color="green"
                closable
                style={{ userSelect: 'none' }}
                onClose={() =>
                  changeSearchState({
                    ...searchState,
                    packageNumber: undefined,
                  })
                }
              >
                Богц - {searchState.packageNumber}
              </Tag>
            )}
          </>
        }
      >
        <Space wrap style={{ marginBottom: 15 }}>
          <Input.Search
            allowClear
            placeholder="Илгээмжийн дугаар"
            value={query}
            onChange={(e) => changeQuery(e.target.value)}
            onSearch={(value) => {
              let q = undefined;
              if (value) {
                q = value;
              }
              changeSearch({ query: q });
            }}
            style={{ width: 200 }}
          />
          <CustomerSelect
            showSearch
            allowClear
            value={searchState.customer}
            onChange={(e) => changeSearch({ customer: e })}
          />
          <Select
            value={searchState.hasOrder}
            onChange={(e) => changeSearch({ hasOrder: e })}
            style={{ width: 250 }}
            placeholder="Захиалгын төлөв"
            allowClear
          >
            <Select.Option value="NO">Үүссэн</Select.Option>
            <Select.Option value="YES">Захиалга бэлтгэгдсэн</Select.Option>
          </Select>
          <Select
            value={searchState.hasPackage}
            onChange={(e) => changeSearch({ hasPackage: e })}
            style={{ width: 250 }}
            placeholder="Богц"
            allowClear
          >
            <Select.Option value="YES">Богцонд орсон</Select.Option>
            <Select.Option value="NO">Богцонд ороогүй</Select.Option>
          </Select>
        </Space>
        <Table
          pagination={{
            pageSize: state.result.size,
            current: state.result.page,
            total: state.result.total,
          }}
          onChange={handleTableChange}
          loading={state.loading}
          dataSource={state.result.data}
          columns={columns}
          rowKey="no"
        />
      </Card>
      <ScanModal open={false} list={[]} onInsert={(e) => console.log(e)} />
      <CreateOrderdraftPackage
        visible={showCreatePackage}
        onClose={() => changeShowCreatePackage(false)}
      />
      <DraftParcelDetail
        visible={showDetail.visible}
        item={showDetail.item}
        onClose={() => changeShowDetail({ visible: false })}
      />
    </Layout.Content>
  );
};
export default OrderDraft;
